import { useState } from "#app";
export const usePreviousRoute = () => {
  return useState("previousRoute");
};
